<template>
  <div class="list-section-divider" :data-testid="testid">
    <span class="list-section-divider__label">{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: 'ListSectionDivider',
  props: {
    label: {
      type: String,
      required: true,
    },
    testid: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
/* 「---- ラベル ----」形式。線は端から端まで引かず、左右に余白を残す */
.list-section-divider {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 8px 16px;
  padding: 8px 0;
  font-size: 11px;
  font-weight: 600;
  color: #9e9e9e;
  letter-spacing: 0.04em;
  white-space: nowrap;
}

.list-section-divider::before,
.list-section-divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background: #e0e0e0;
}
</style>
